import React from 'react'
import { Link } from 'gatsby'

export default function Violator(){
    return(
        <Link
            to='/sale'
            className='m-0 d-block text-center text-black bg-primary fw-bold position-relative'
            style={{ zIndex: 3, textWrapStyle: 'balance' }}
            title=' *Some 3rd-party, licensed, and exclusive items may be excluded. Black Friday pricing ends Dec 7, 2025. Buy + Get offers run Nov 3–26, 2025. Prices may vary by exchange rate and local taxes. Final cost may differ from the advertised price. Additional Exclusions may apply.'
        >
            LIMITED TIME OFFER: BUY 2 + GET 15% EXTRA OFF* | BUY 3 + GET 20% EXTRA OFF* ⚡
        </Link>
    )
}
